<template>
  <div style="padding: 1.2%; margin: 0% 1% 0% 1%">
    <b-card style="border-radius: 20px;">
      <div class="m-1" v-if="mostrarBotones">
        <b-row>
          <b-col class="text-left mt-3 ml-2">
            <p class="textoSubtitulo">Sesiones</p>
          </b-col>
          <b-col class="text-right">
            <b-button-group class="ml-3 mt-2 mb-2">
              <b-button
                  :disabled="loaderSesiones"
                  v-b-popover.hover.top="'Actualizar bandeja'"
                  v-on:click="cerrarModal(1)"
                  class="iconos-atajo m-1"
              >
                <img alt="sesiones" class="imagen-tratamiento" width="20px" :src="require ('/src/assets/nuevoDashboard/refresh.svg')">
                <b-spinner small variant="primary" v-if="loaderSesiones"></b-spinner>
              </b-button>
            </b-button-group>
          </b-col>
        </b-row>
      </div>
      <b-row>
        <b-col sm="12" md="12" lg="12">
          <div class="contenedorTablaSinColor">
            <b-table-simple sticky-header responsive>
              <b-thead class="columnasTablaSinColor">
                <b-tr>
                  <b-th class="border-top-0" v-for="(fieldsTablas, index) in fieldsTablasCaja" :key="index">
                    {{ fieldsTablas.label }}
                    <em class="fa fa-filter" v-if="fieldsTablas.filtro" @click="abrirModalFiltro(index)">

                    </em>
                    <em class="fa fa-times" style="color: red" v-if="index === indexFiltro"
                        @click="eliminarFiltro()"></em>
                  </b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr v-for="(citasCaja, index) in citasCaja" :key="index">
                  <b-td>{{ citasCaja.idPaciente }}</b-td>
                  <b-td style="text-align: center;">
                                 <span v-if="$localStorageService.can('CA_03_menu')">
                    <div>
                      <div
                          v-if="citasCaja.estatusPacienteColorDTO != null"
                      >
                        <span v-if="citasCaja.idSesion != null">
                          <router-link
                              :to="{ name: 'pacienteses', params: { id: citasCaja.idPaciente , sesion: citasCaja.idSesion} }"
                          >
                            <span :style="'color:' + citasCaja.estatusPacienteColorDTO.color+'!important'">{{ citasCaja.nombrePaciente }}</span>
                          </router-link>
                        </span>
                        <span v-else>
                          <router-link
                              :to="{ name: 'paciente', params: { id: citasCaja.idPaciente} }"
                          >
                            <span :style="'color:' + citasCaja.estatusPacienteColorDTO.color+'!important'">
                              {{ citasCaja.nombrePaciente }}
                            </span>
                          </router-link>
                        </span>
                      </div>
                      <div v-else style="color: #000000">
                        {{ citasCaja.nombrePaciente }}
                      </div>
                    </div>
                  </span>
                    <span v-else>
            <p class="disabledSesion">
              {{ citasCaja.nombrePaciente }}
            </p>
                </span>
                  </b-td>
                  <b-td>{{ citasCaja.idEstadoPaciente == null || citasCaja.idEstadoPaciente === 1 ? 'Primera Vez': citasCaja.idEstadoPaciente === 2 ?'Frecuente':citasCaja.idEstadoPaciente === 3? 'Dormido':'' }}</b-td>
                  <b-td>{{citasCaja.nivelPTI}}</b-td>
                  <b-td style="text-align: center;">
                   <span
                       v-if="citasCaja.activa && $localStorageService.can('RE_05_menu') && !citasCaja.citaEmbajador"
                   >
            <router-link
                :to="{
                name: 'tratamientoSesion',
                params: {
                  idSesion: citasCaja.idSesion,
                  idPaciente: citasCaja.idPaciente,
                  idDoctor: citasCaja.idDoctor,
                  nombre: citasCaja.nombrePaciente,
                },
              }"
            >
              {{ citasCaja.nombreDoctor }}
            </router-link>
          </span>
                    <span v-else>
            <p class="disabledSesion">
              {{ citasCaja.nombreDoctor }}
            </p>
          </span>
                  </b-td>
                  <b-td>{{ citasCaja.sillon }}</b-td>
                  <b-td style="text-align: center">
                     <span v-if="citasCaja.colorS === true" :style="'color: #ffbd11'">
                        {{ citasCaja.horaInicioCita }}<br>
                        {{ citasCaja.horaFinCita }}
                    </span>
                    <span v-else-if="citasCaja.colorS === false" :style="'color: #1e9303'">
                        {{ citasCaja.horaInicioCita }}<br>{{ citasCaja.horaFinCita }}
                    </span>
                    <span v-else v-bind:class="{ disabledSesion: !citasCaja.activa }">
                        {{ citasCaja.horaInicioCita }}<br>{{ citasCaja.horaFinCita }}
                    </span>
                  </b-td>
                  <b-td>
                  <span v-if="citasCaja.citaProceso">
                      <b-icon
                          v-b-tooltip.hover
                          :title=" 'Cita En Proceso' "
                          icon="circle-fill"
                          aria-hidden="true"
                          font-scale="2"
                          :style="{ color: '#FBB917' }"
                      ></b-icon>
                    </span>
                  </b-td>
                  <b-td>
                      <span v-if="idClinica === 181">
            <b-button :disabled="idClinica === 181" v-b-popover.hover.left="'Pagar sesión'">
                <em class="fa fa-dollar"></em>
              </b-button>
          </span>
                    <div v-else>
            <span
                v-if="(citasCaja.activa && citasCaja.citaDia === false
                &&  citasCaja.citaProceso === false
                && ( citasCaja.tieneTratamientosActuales || citasCaja.distribucion)
                && $localStorageService.can('CA_01_caja_cobro'))">
            <router-link
                :to="{
                name: 'cajaSesion',
                params: {
                  idSesion: citasCaja.idSesion
                },
              }"
            >
              <b-button variant="outline-success" v-b-popover.hover.left="'Pagar sesión'">
                <em class=" fa fa-dollar"></em>
              </b-button>
            </router-link>
          </span>
                    </div>
                  </b-td>
                  <b-td>
                    <div v-if="idClinica === 181">
           <span v-if="citasCaja.activa">
          </span>
                      <span v-else>
            <b-icon icon="x" font-scale="1.5" class="black"></b-icon>
          </span>
                    </div>
                    <div v-else>
            <span
                v-if="(citasCaja.estatusCita === 11 || citasCaja.estatusCita === 5 || citasCaja.estatusCita === 24 || citasCaja.estatusCita === 26) || (citasCaja.activa) || (citasCaja.activa && citasCaja.citaEmbajador && citasCaja.recibo)">
              <em style="font-size: 15px; color: #D32E05;" class="fa fa-times"></em>
          </span>
                      <span v-else>
            <b-iconstack font-scale="2">
              <b-icon stacked icon="check-circle" style="color: #0ca30a"></b-icon>
            </b-iconstack>
          </span>
                    </div>
                  </b-td>
                  <b-td>
                    <div v-if="citasCaja.distribucion">
                      <!-- <em style="font-size: 15px; color: #11dc21;" class="fa fa-check"></em> -->

                      <b-iconstack font-scale="2">
                        <b-icon stacked icon="check-circle" style="color: #0ca30a"></b-icon>
                      </b-iconstack>
                    </div>
                    <div v-else>
                      <!-- <em style="font-size: 15px; color: #D32E05;" class="fa fa-times"></em>-->
                      <em style="font-size: 15px; color: #D32E05;" class="fa fa-times"></em>
                    </div>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
            <span v-if="loaderAcciones3">
            <b-spinner variant="primary"></b-spinner>
          </span>
            <b-alert v-if="citasCaja.length === 0" variant="warning" show>No hay citas</b-alert>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-modal
        size="md"
        v-model="modalFiltros"
        id="modalFiltros"
        :title="'Filtro '+filtroText"
        :hide-footer="true"
        :no-close-on-backdrop="true"
    >
      <br/>
      <div>
        <b-input-group v-if="indexFiltro === 0" size="md" :prepend="filtroText">
          <b-form-input v-model="idPaciente"></b-form-input>
        </b-input-group>
        <b-input-group v-if="indexFiltro === 1" size="md" :prepend="filtroText">
          <b-form-input v-model="nombrePacienteFiltro"></b-form-input>
        </b-input-group>
        <b-input-group v-if="indexFiltro === 4" size="md" :prepend="filtroText">
          <b-form-input v-model="nombreDoctorFiltro"></b-form-input>
        </b-input-group>
        <b-input-group v-if="indexFiltro === 5" size="md" :prepend="filtroText">
          <b-form-input v-model="numeroSillonFiltro"></b-form-input>
        </b-input-group>
        <div v-if="indexFiltro === 9">
          <b-form-group v-slot="{ ariaDescribedby }">
            <b-form-radio class="m-4" v-model="tipoFiltro" :aria-describedby="ariaDescribedby" name="some-radios" :value="1">
              <b-icon
                  v-b-tooltip.hover
                  :title=" 'Cita No Confirmada' "
                  icon="circle-fill"
                  aria-hidden="true"
                  font-scale="2"
                  :style="{ color: '#CCCCCC' }"
              ></b-icon> Cita No Confirmada
            </b-form-radio>
            <b-form-radio class="m-4" v-model="tipoFiltro" :aria-describedby="ariaDescribedby" name="some-radios" :value="2">
              <b-icon
                  v-b-tooltip.hover
                  :title=" 'Cita Confirmada' "
                  icon="circle-fill"
                  aria-hidden="true"
                  font-scale="2"
                  :style="{ color: '#6495ED' }"
              ></b-icon> Cita Confirmada
            </b-form-radio>
          </b-form-group>
        </div>
        <div v-if="indexFiltro === 10">
          <b-form-group v-slot="{ ariaDescribedby }">
            <b-form-radio class="m-4" v-model="tipoFiltro" :aria-describedby="ariaDescribedby" name="some-radios" :value="3">
              <b-icon
                  v-b-tooltip.hover
                  :title=" 'Cita En Proceso' "
                  icon="circle-fill"
                  aria-hidden="true"
                  font-scale="2"
                  :style="{ color: '#FBB917' }"
              ></b-icon> Cita En Proceso
            </b-form-radio>
          </b-form-group>
        </div>
        <div v-if="indexFiltro === 11">
          <b-form-group v-slot="{ ariaDescribedby }">
            <b-form-radio class="m-4" v-model="tipoFiltro" :aria-describedby="ariaDescribedby" name="some-radios" :value="4">
              <b-button class="m-4" variant="outline-success">
                <em class=" fa fa-dollar"></em>
              </b-button> Cita En Caja
            </b-form-radio>
          </b-form-group>
        </div>
        <div class="text-center" v-if="indexFiltro === 2">
          <b-form-radio-group v-model="tipoFlujoFiltro" :options="tipoPaciente" :state="state" name="radio-validation">
          </b-form-radio-group>
        </div>
        <div class="text-center" v-if="indexFiltro === 6">
          <b-row>
            <b-col>
              <validation-provider
                  :rules="{ required: true }"
                  v-slot="errors"
              >
                <label>Hora inicio</label>
                <b-form-group>
                  <vue-timepicker
                      id="idHoraInicio"
                      hide-disabled-items
                      v-model="horaInicioFiltro"
                      format="HH:mm"
                      :minute-interval="15"
                      hide-clear-button
                  ></vue-timepicker>

                  <validacion
                      :texto="errors.errors[0] ? errors.errors[0] : ' '"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col>
              <validation-provider
                  :rules="{ required: true }"
                  v-slot="errors"
              >
                <label>Hora fin</label>
                <b-form-group>
                  <vue-timepicker
                      id="idHoraFin"
                      hide-disabled-items
                      v-model="horaFinFiltro"
                      format="HH:mm"
                      :minute-interval="15"
                      hide-clear-button
                  ></vue-timepicker>

                  <validacion
                      :texto="errors.errors[0] ? errors.errors[0] : ' '"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </div>
        <div class="text-center" v-if="indexFiltro === 7">
          <b-row>
            <b-col>
              <validation-provider
                  :rules="{ required: true }"
                  v-slot="errors"
              >
                <label>Hora inicio</label>
                <b-form-group>
                  <vue-timepicker
                      id="idHoraInicio"
                      hide-disabled-items
                      v-model="horaInicioFiltro"
                      format="HH:mm"
                      :minute-interval="15"
                      hide-clear-button
                  ></vue-timepicker>

                  <validacion
                      :texto="errors.errors[0] ? errors.errors[0] : ' '"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col>
              <validation-provider
                  :rules="{ required: true }"
                  v-slot="errors"
              >
                <label>Hora fin</label>
                <b-form-group>
                  <vue-timepicker
                      id="idHoraFin"
                      hide-disabled-items
                      v-model="horaFinFiltro"
                      format="HH:mm"
                      :minute-interval="15"
                      hide-clear-button
                  ></vue-timepicker>

                  <validacion
                      :texto="errors.errors[0] ? errors.errors[0] : ' '"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </div>
        <div class="text-center" v-if="indexFiltro === 8">
          <b-row>
            <b-col>
              <validation-provider
                  :rules="{ required: true }"
                  v-slot="errors"
              >
                <label>Hora inicio</label>
                <b-form-group>
                  <vue-timepicker
                      id="idHoraInicio"
                      hide-disabled-items
                      v-model="horaInicioFiltro"
                      format="HH:mm"
                      :minute-interval="15"
                      hide-clear-button
                  ></vue-timepicker>

                  <validacion
                      :texto="errors.errors[0] ? errors.errors[0] : ' '"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col>
              <validation-provider
                  :rules="{ required: true }"
                  v-slot="errors"
              >
                <label>Hora fin</label>
                <b-form-group>
                  <vue-timepicker
                      id="idHoraFin"
                      hide-disabled-items
                      v-model="horaFinFiltro"
                      format="HH:mm"
                      :minute-interval="15"
                      hide-clear-button
                  ></vue-timepicker>

                  <validacion
                      :texto="errors.errors[0] ? errors.errors[0] : ' '"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </div>
        <br/>
        <b-button
            v-show="!loaderAcciones3"
            class="mt-3"
            variant="outline-success"
            block
            @click="traerCitasActivasCaja()"
        >Aceptar
        </b-button>
        <b-button class="mt-3" block variant="outline-primary" v-show="loaderAcciones3" disabled>
          <b-spinner small></b-spinner>
          Cargando...
        </b-button>
        <b-button
            class="mt-3"
            variant="outline-info"
            block
            @click="cerrarModal(1)"
        >Cerrar
        </b-button
        >
        <br/><br/>
      </div>
    </b-modal>

  </div>
</template>

<script>
export default {
  name: "sesionesDashboard",
  data: () => ({
    loaderSesiones: false,
    idPaciente: 0,
    filterOn: [],
    loader: false,
    loaderAcciones1: false,
    loaderAcciones2: false,
    loaderAcciones3: false,
    fieldsTablas: [
      {key: "nombrePaciente", label: "Paciente"},
      {key: "nombreDoctor", label: "Doctor"},
      {key: "sillon", label: "Sillón"},
      {key: "horario", label: "Horario"}
    ],
    fieldsTablasCaja: [
      {key: "idPaciente", label: "id Paciente", filtro: true},
      {key: "nombrePaciente", label: "Paciente", filtro: true},
      {key: "idEstadoPaciente", label: "Estado del Paciente", filtro: true},
      {key: "nivelPTI", label: "Nivel PTI", filtro: false},
      {key: "nombreDoctor", label: "Doctor", filtro: true},
      {key: "sillon", label: "Sillón", filtro: true},
      {key: "horaInicioCita", label: "Horario", filtro: true},
      //{key: "horaInicio", label: "Entró", filtro: true},
      //{key: "horaFin", label: "Salió",filtro: true},
      //{key: "citaDia", label: "del día", filtro: true},
      {key: "citaProceso", label: "en Proceso", filtro: true},
      {key: "activa", label: "Pago", filtro: true},
      {key: "citaEmbajador", label: "Fin"},
      {key: "distribucion", label: "Distribución"}
    ],
    proximasCitas: [],
    citasProceso: [],
    citasCaja: [],
    modalFiltros: false,
    filtroText: "",
    indexFiltro: null,
    nombrePacienteFiltro: "",
    tipoFiltro: 0,
    nombreDoctorFiltro: "",
    tipoPaciente: [
      { text: 'Primera Vez', value: 1 },
      { text: 'Frecuente', value: 2 },
      { text: 'Dormido', value: 3 }
    ],
    tipoFlujoFiltro: null,
    numeroSillonFiltro: 0,
    horaInicioFiltro: [],
    horaFinFiltro: [],
    tipoHorario: 0,
    mostrarBotones: true
  }),
  created() {
    this.traerCitasActivasCaja();

  },
  methods: {
    traerCitasActivasCaja() {
      this.citasCaja = [];
      let fechaActual = this.$moment().format("YYYY-MM-DD")+"T00:00:00-06:00";
      this.loaderAcciones3 = true;
      if(this.tipoFiltro === 0 || this.tipoFiltro === 3 || this.tipoFiltro === 4){
        let  filtro = {
          idClinica: this.idClinica,
          fechaInicio: fechaActual,
          idTipoPaciente: this.tipoFlujoFiltro,
          idPaciente: this.idPaciente,
          nombrePaciente: this.nombrePacienteFiltro,
          tipoEstatusCita: this.tipoFiltro,
          nombreDoctor: this.nombreDoctorFiltro,
          numeroSillon: this.numeroSillonFiltro,
          tipoHorario: this.tipoHorario,
          horaInicio: parseInt(this.horaInicioFiltro.HH + this.horaInicioFiltro.mm),
          horaFin: parseInt(this.horaFinFiltro.HH + this.horaFinFiltro.mm)
        }
        this.$http.post(
            this.$api + 'dashboard/listaSesionesActivasCaja', filtro).then(respuesta => {
          if (respuesta.data.data) {
            this.citasCaja = respuesta.data.data;
          }
        }).catch(error => {
          console.error(error);
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: "Hubo un problema al obtener las citas en caja.",
          });
        }).finally(() => {
          this.coloresSesiones();
        })
      }else{
        this.llenarCitasActivas();
      }
    },
    coloresSesiones(){
      this.$http.post(
          this.$api + 'dashboard/colorSesionesActivasCaja', this.citasCaja).then(respuesta => {
        if (respuesta.data.data) {
          let colores = respuesta.data.data;
          this.citasCaja.forEach(element => {
            let estatusColor = colores.filter(color => color.idSesion === element.idSesion);
            element.estatusPacienteColorDTO = estatusColor[0].estatusPacienteColorDTO;
          })
        }
      }).catch(error => {
        console.error(error);
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: "Hubo un problema al obtener las citas en caja.",
        });
      }).finally(() => {
        this.loaderAcciones3 = false;
        this.cerrarModal(0);
      })
    },
    llenarCitasActivas(){
      this.loaderAcciones3 = true;
      this.$http.post(
          this.$api + 'dashboard/datosSesionesActivasCaja', this.citasCaja).then(respuesta => {
        if (respuesta.data.data) {
          this.citasCaja = respuesta.data.data;
        }
      }).catch(error => {
        console.error(error);
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: "Hubo un problema al obtener las citas en caja.",
        });
      }).finally(() => {
        this.loaderAcciones3 = false;
        this.cerrarModal(0);
      })
    },
    buscarPaciente() {
      this.proximasCitas = [];
      this.citasProceso = [];
      this.citasCaja = []
      this.traerCitasActivasCaja();
    },
    abrirModalFiltro(index) {
      this.modalFiltros = true
      this.indexFiltro = index;
      if (this.indexFiltro === 0) {
        this.filtroText = "Id Paciente";
      } else if (this.indexFiltro === 1) {
        this.filtroText = "Nombre Paciente";
      } else if (this.indexFiltro === 2) {
        this.filtroText = "Estado del Paciente";
      }else if (this.indexFiltro === 4) {
        this.filtroText = "Nombre Doctor";
      }else if (this.indexFiltro === 5) {
        this.filtroText = "Sillón";
      }else if (this.indexFiltro === 6) {
        this.filtroText = "Horario";
        this.tipoHorario = 1;
      } else if (this.indexFiltro === 7) {
        this.filtroText = "Entró";
        this.tipoHorario = 2;
      }else if (this.indexFiltro === 8) {
        this.filtroText = "Salió";
        this.tipoHorario = 3;
      } else if (this.indexFiltro === 9) {
        this.filtroText = "Cita del Día";
      } else if (this.indexFiltro === 10) {
        this.filtroText = "Cita en Proceso";
      }else if (this.indexFiltro === 11) {
        this.filtroText = "Cita en Caja";
      }
    },
    cerrarModal(tipo) {
      this.modalFiltros = false;
      if (tipo === 1) {
        this.eliminarFiltro();
      }
    },
    eliminarFiltro() {
      this.indexFiltro = null;
      this.idPaciente = 0;
      this.nombrePacienteFiltro = "";
      this.tipoFiltro = 0;
      this.tipoFlujoFiltro = null;
      this.nombreDoctorFiltro = "";
      this.numeroSillonFiltro = 0;
      this.tipoHorario = 0;
      this.horaInicioFiltro = [];
      this.horaFinFiltro = [];
      this.traerCitasActivasCaja();
    },
  },
  computed: {
    idClinica() {
      return this.$localStorageService.getIdClinica() !== undefined &&
      this.$localStorageService.getIdClinica() !== null &&
      this.$localStorageService.getIdClinica() > 0
          ? this.$localStorageService.getIdClinica()
          : this.$clinicaIdDefecto;
    }
  },
  watch: {
    idPaciente(newVal) {
      if (newVal === '') {
        this.buscarPaciente()
      }
    }
  },

}
</script>

<style scoped>
.barra {
  border-width: 1px;
  border-style: solid;
  border-color: #c2e7ff;
  background: #ffffff;
  margin: 1rem;
  padding: 5px;
  border-radius: 6px;
  text-align: left;
  align-items: center;
}

.contenedorTablaSinColor {
  padding: 8px;
  height: 60vh;
}

.input-filter,
.input-filter:focus {
  background: transparent;
  border: 0px;
  box-shadow: 0 0 0 0 rgb(0 123 255 / 25%);
}

.table.b-table > thead > tr > .table-b-table-default {
  color: #5d5d5d !important;
  background-color: #ffffff !important;
}

.b-table-sticky-header {
  max-height: 60vh !important; /* Tamaño máximo de la tabla, ajusta el valor según tus necesidades */
  overflow-y: auto !important; /* Habilita la barra de desplazamiento vertical */
  ext-align: initial !important;
}
.card-body {
  padding: 0.25rem;
}

.close {
  display: none !important;
}

#btnScrollToTop{
  position: fixed;
  right: 35px;
  bottom:  322px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: linear-gradient(to right, #5f9ccb 0%, #0975c2 100%);
  box-shadow: 0 0 10px rgba(0,0,0,0.25);
  color: #ffff;
  border: none;
  outline: none;
  cursor: pointer;
}
.refresh{
  border-radius: 49%;
  box-shadow: 0px 10px 10px -6px black;
  color: #f6f6f6;
}

.iconos-atajo{
  border-radius: 49%;
  -webkit-box-shadow: 0px 10px 10px -6px black;
  box-shadow: 0px 10px 10px -6px black;
  background: white;
  border-color:  #1B81AF;
}

.iconos-atajo:hover {
  color: #fff;
  background-color: #A2DAE3;
  border-color: #A2DAE3;
}

.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #A2DAE3;
  border-color: #A2DAE3;
}
</style>
